import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import "../has.js";
import e from "../Logger.js";
import { get as o } from "./get.js";

function t(e, r, s) {
  if (e && r) if ("object" == typeof r) {
    var _iterator = _createForOfIteratorHelper(Object.getOwnPropertyNames(r)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _o = _step.value;
        t(e, _o, r[_o]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  } else {
    if (-1 !== r.indexOf(".")) {
      var i = r.split("."),
          f = i.splice(i.length - 1, 1)[0];
      return void t(o(e, i), f, s);
    }

    e[r] = s;
  }
}

e.getLogger("esri.core.accessorSupport.set");
export { t as default, t as set };